/**
 * Sentry Types. These may not be accurate but we just need typescript happy
 */
interface SentryScope {
	setFingerprint(fingerprint: any[]): void;

	// Debug, error,or other...
	setLevel(level: string): void;
	setExtra(key: string, value: string): void;
}

interface SentryHub {
	onLoad(callback: () => void): void;
	init(settings: any): void;
	withScope(cb: (scope: SentryScope) => void): void;
	captureException(ex: Error): void;
	captureMessage(message: string, level?: string): void;
	getCurrentHub(): SentryHub;
}

declare const Sentry: SentryHub;

function initSentry(_release: string, _dsn: string) {
	// Sentry has been discontinued - function is now a no-op
	// All parameters are ignored
}

/**
 * Used to capture a exception with sentry
 *
 * @param error The error/exception to report
 * @param extra Details to include with the sentry report
 * @param fingerprint Fingerprint to identify a sequence of events?
 */
function captureSentryException(_error: Error, _extra?: Record<string, any> | null, _fingerprint?: any[] | null) {
	// Sentry has been discontinued - function is now a no-op
	// All parameters are ignored
}

export {
	initSentry,
	captureSentryException,
};
